import common from "@/assets/js/common";
import Vue from 'vue';
const vm = new Vue();
let abortController = new AbortController();

/**
 * 解析 SSE 文本，提取完整的消息事件。
 * 返回 { events: string[], rest: string }
 *   - events: 本轮解析出的完整消息数组（不含最后一行空行）
 *   - rest:   未完成的尾部，留给下次拼上
 */
function parseSSEBuffer(buffer) {
  const events = [];
  // SSE 消息以 \n\n 或 \r\n\r\n 分隔
  const parts = buffer.split('\n\n');
  // 最后一段可能是不完整的消息，留着下次拼
  for (let i = 0; i < parts.length - 1; i++) {
    events.push(parts[i]);
  }
  return { events, rest: parts[parts.length - 1] };
}

export async function fetchSSE(url, data, onDataReceived, onMessage) {
    abortController = new AbortController();
    const response = await fetch((process.env.NODE_ENV=='development'?'/api':'/ai')+url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': "Bearer " + common.getCookie("token"),
            'Accept': 'text/event-stream',
        },
        // signal 是 fetch 的顶层选项，不是 header
        signal: abortController.signal,
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        vm.$msg({
            message: response.statusText,
            type: "error",
            showClose: true,
            duration: 2 * 1000
        });
        onDataReceived && onDataReceived('request_error');
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    while (true) {
        const { done, value } = await reader.read();
        if (done || abortController.signal.aborted) break;
        // 1) 解码当前 chunk 并拼到缓冲区
        buffer += decoder.decode(value, { stream: true });

        // 2) 按 \n\n 切分，提取完整消息
        const { events, rest } = parseSSEBuffer(buffer);
        buffer = rest;

        for (const event of events) {
            const raw = event.replace(/\r?\n$/, '');

            // 尝试按 SSE data: 前缀切分
            const dataLines = raw
                .split('\n')
                .filter(line => line.startsWith('data:'))
                .map(line => line.slice(5).trim());

            if (dataLines.length > 0) {
                // SSE 格式：有 data: 前缀
                const payload = dataLines.join('\n');
                if (onMessage) onMessage(payload);
                if (onDataReceived) {
                    try {
                        onDataReceived(JSON.parse(payload));
                    } catch {
                        onDataReceived(payload);
                    }
                }
            } else {
                // 非 SSE 格式：直接当 JSON 处理
                if (onDataReceived) {
                    try {
                        onDataReceived(JSON.parse(raw));
                    } catch {
                        onDataReceived(JSON.parse(raw));
                    }
                }
            }
        }
    }
}
export function stopFetchSSE() {
    abortController.abort()
}
